__turbopack_context__.v({
  "animatedgradient": "WbLTgW_animatedgradient",
  "imgD": "WbLTgW_imgD",
  "imgDesktop": "WbLTgW_imgDesktop",
  "imgMobile": "WbLTgW_imgMobile",
  "ogdbContent": "WbLTgW_ogdbContent",
  "ogdbRoot": "WbLTgW_ogdbRoot",
  "root": "WbLTgW_root",
  "w60": "WbLTgW_w60",
  "w75": "WbLTgW_w75",
});
